import categoryName from 'allpages/basicData/CATEGORY_NAME.vue';
export default {
  components: {
    categoryName
  },
  data() {
    return {
      loading: false,
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('com.cancel'),
            btnclick: () => {
              this.$emit('on-cancel')
            } // 按钮点击事件
          },
          {
            type: 'primary',
            text: $it('com.determine'),
            loading: false,
            btnclick: () => {
              this.submit();
            }
          }
        ]
      },
      formConfig: {
        formValue: {
          PS_C_PRO_ID: '', // SPU编码
          PS_C_PRO_ENAME: '', // SKU名称
          ECODE: '', // 条码
          PS_C_BRAND_ID: '',
          PS_C_CATEGORY_ID: '', // 商品品类
          PS_C_SPEC1OBJ_ID: [], // 颜色
          PS_C_SPEC2OBJ_ID: [], // 尺寸
        },
        formData: [
          {
            style: 'dropSelect', // 输入框类型
            width: '8',
            itemdata: {
              col: 2,
              colid: 136292, // 字段id
              colname: 'PS_C_PRO', // 当前字段的名称 用来显示的
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_PRO:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: $it('tL.productNo'), // SPU编码
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_PRO', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_PRO_ID = e.pid
            },
          },
          {
            style: 'input', // 输入框类型
            label: 'SKU名称',
            value: 'PS_C_PRO_ENAME', // 输入框的值
            width: '8', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
            placeholder: '请完成输入后回车',
            disabled: false,
            inputChange: () => {
            },
            inputenter: (val) => {
              this.request()
            }
          },
          {
            style: 'input', // 输入框类型
            label: $it('fL.barCode'), // 条码
            value: 'ECODE', // 输入框的值
            width: '8', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
            disabled: false,
            inputChange: () => {
            },
            inputenter: (val) => {
              this.request()
            }
          },
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              colid: 168733,
              colname: 'PS_C_SPEC1OBJ_ID', // 当前字段的名称
              fkdisplay: 'mrp', // 外键关联类型
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: '颜色', // 物流公司 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (e) => {
              console.log(e)
              this.formConfig.formValue.PS_C_SPEC1OBJ_ID = e.pid.split(',');
            },
          },
          {
            style: 'dropSelect',
            width: '8',
            itemdata: {
              colid: 168734,
              colname: 'PS_C_SPEC2OBJ_ID', // 当前字段的名称
              fkdisplay: 'mrp', // 外键关联类型
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              name: '尺寸', // 物流公司 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (e) => {
              console.log(e)
              this.formConfig.formValue.PS_C_SPEC2OBJ_ID = e.pid.split(',');
            },
          },
          {
            style: 'dropSelect', // 输入框类型
            width: '8',
            itemdata: {
              col: 2,
              colid: 166758, // 字段id
              colname: 'PS_C_BRAND', // 当前字段的名称 用来显示的
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: '品牌',
              inputname: 'PS_C_BRAND:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: $it('tL.brand'), // 品牌
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'PS_C_BRAND', // 对应的表
              reftableid: 23051, // 对应的表ID
              pid: '',
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              this.formConfig.formValue.PS_C_BRAND_ID = e.pid
            },
          },
          {
            style: 'formCompile', // 输入框类型
            label: '商品品类',
            slotName: 'formCompile',
            value: 'PS_C_CATEGORY_ID', // 输入框的值
            width: '8', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
          },
        ],
      }, // 表单配置
      businessButtonConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'left', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('btn.find'), // 查找
            type: 'primary',
            btnclick: () => {
              this.request()
            } // 按钮点击事件
          },
          {
            text: $it('btn.reset'), // 重置
            btnclick: () => {
              $utils.formEmpty(this, 'formConfig')
              this.$refs.categoryName.valuedata = '' // 重置商品品类
              this.request()
            } // 按钮点击事件
          }
        ],
      },
      tableConfig: {
        pageShow: true, // 控制分页是否显示
        btnsShow: true, // 控制操作按钮是否显示
        indexColumn: true,
        // 是否存在多选框
        isShowSelection: true,
        loading: false, // 加载
        height: '300', // 表格高度
        border: true, // 是否显示纵向边框
        current: 1, // 当前页
        total: 0, // 设置总条数
        pageSizeOpts: [50, 100, 150, 200], // 每页条数切换的配置
        pageSize: 50, // 每页条数
        data: [],
        selectionData: [],
        columns: [
          // 表头
          {
            title: $it('fL.barCode'), // 条码
            key: 'PS_C_SKU_ECODE',
          },
          {
            title: 'SKU名称',
            key: 'PS_C_PRO_ENAME',
          },
          {
            title: $it('fL.cu'), // 零售价
            key: 'PRICELIST',
          },
          {
            title: $it("other.color"), // 颜色
            key: 'PS_C_SPEC1OBJ_ID'
          },
          {
            title: $it('other.sizes'), // 尺寸
            key: 'PS_C_SPEC2OBJ_ID'
          },
          {
            title: '销售属性', // 销售属性
            key: 'SALES_ATTRIBUTE',
            render: (h, params) => {
              if (!params.row.SALES_ATTRIBUTE) return h('span', {}, '')
              let fields = params.row.SALES_ATTRIBUTE.split(';')
              let nodes = fields.map(item => {
                return h('li', {}, [h('span', {}, item)])
              })
              return h('Poptip',
                {
                  props: {
                    placement: 'top',
                    transfer: true,
                    trigger: 'hover',
                    width: '100px'
                  },
                }, [
                  h('div', { class: 'extend-attrs' }, params.row.SALES_ATTRIBUTE),
                  h('div', { slot: 'content' }, [h('div', {}, [h('ul', {}, nodes)])])
                ]
              )
            }
          },
          {
            title: '国际码', // 国际码
            key: 'GBCODE',
          },
          {
            title: $it('tL.brand'), // 品牌
            key: 'PS_C_BRAND_ID',
          },
          {
            title: '商品品类', // 商品品类
            key: 'PS_C_CATEGORY_ID',
          },
        ]
      }
    };
  },
  mounted() {
    this.onBeforeHandle()
    const { customizedModuleName } = this.$route.params
    if (['ORDERMANAGEADD', 'PM_C_PROM_ACTI'].includes(customizedModuleName)) {
      /**
       * 零售新增、促销
       * 1.【添加商品SKU】弹窗打开默认不刷数据
       * 2. 显示【是否组合商品】表单筛选字段及表格列
       */
      this.formConfig.formData.push({
        style: 'select',
        label: '是否组合商品',
        value: 'IS_GROUP',
        width: '8',
        multiple: true,
        options: [
          { label: '是', value: 'Y' },
          { label: '否', value: 'N' },
        ],
      })
      this.$set(this.formConfig.formValue, 'IS_GROUP', 'N')
      this.tableConfig.columns.push({
        title: '是否组合商品',
        key: 'IS_GROUP',
      })
      return
    }
    if (['COMBINEDCOMMODITY'].includes(customizedModuleName)) return // 组合商品默认不加载数据
    this.request()
  },
  methods: {
    // 查找成分商品
    request() {
      this.tableConfig.loading = true
      // 本页面只展示 商品SKU表中【可用】= “是”且【是否组合商品】= “否” 的数据，零售新增除外-【可用】= “是”
      const self = this;
      let params = {
        table: 'PS_C_SKU_GROUP_DIALOG',
        fixedcolumns: {
          IS_GROUP: ["=N"],
          ISACTIVE: ["=Y"]
        },
        startindex: (this.tableConfig.current -1) * this.tableConfig.pageSize,
        range: this.tableConfig.pageSize,
        column_include_uicontroller: true,
        isolr: false
      }

      // 其它筛选条件处理
      const { valuedata, category } = this.$refs.categoryName
      if (!!valuedata) {
        params.fixedcolumns.PS_C_CATEGORY_ID = [category.id]
      }
      for (let key in this.formConfig.formValue) {
        const val = this.formConfig.formValue[key]
        if (Array.isArray(val) && val.length && val[0] != '' || !Array.isArray(val) && val.length) {
          params.fixedcolumns[key] = val
        }
        if (key == 'IS_GROUP') {
          // 零售新增- 是否组合商品字段值处理
          if (val) {
            if (Array.isArray(val)) {
              if (val.length) {
                params.fixedcolumns.IS_GROUP = val.map(i => `=${i}`)
              } else {
                delete params.fixedcolumns.IS_GROUP
              }
            } else {
              params.fixedcolumns.IS_GROUP = [`=${val}`]
            }
          } else {
            delete params.fixedcolumns.IS_GROUP
          }
        }
      }
      const formdata = new FormData()
      formdata.append('searchdata', JSON.stringify(params))
      self.service.common.QueryList(formdata).then((res) => {
        this.tableConfig.loading = false
        if (res.data.code === 0) {
          const data = res.data.datas.row || [];
          const arr = []; // 展示的数据
          data.forEach((item) => {
            // 获取想要展示的
            let boolean = new Map([
              ['是', 'Y'],
              ['否', 'N'],
            ])
            arr.push({
              ID: item.ID.val,
              PS_C_SKU_ECODE: item.ECODE.val, // 条码
              PS_C_PRO_ECODE: item.PS_C_PRO_ID.val, // SPU编码
              PS_C_PRO_ENAME: item.PS_C_PRO_ENAME.val, // SKU名称
              PS_C_SPEC1OBJ_ID: item.PS_C_SPEC1OBJ_ID ? item.PS_C_SPEC1OBJ_ID.val : '', // 颜色
              PS_C_SPEC2OBJ_ID: item.PS_C_SPEC2OBJ_ID ? item.PS_C_SPEC2OBJ_ID.val : '', // 尺码
              PS_C_CLR_ENAME: item.PS_C_SPEC1OBJ_ID ? item.PS_C_SPEC1OBJ_ID.val : '', // 颜色
              PS_C_SIZE_ENAME: item.PS_C_SPEC2OBJ_ID ? item.PS_C_SPEC2OBJ_ID.val : '', // 尺码
              SALES_ATTRIBUTE: item.SALES_ATTRIBUTE.val, // 销售属性
              GBCODE: item.GBCODE.val, // 国际码
              PS_C_BRAND_ID: item.PS_C_BRAND_ID.val, // 品牌
              PS_C_CATEGORY_ID: item.PS_C_CATEGORY_ID.val, // 商品品类
              // IS_GIFT: boolean.get(item.IS_GIFT.val), // 是否赠品
              IS_GIFT: item.IS_GIFT.val, // 是否赠品 由于'queryProduct'方法中是用'是/否'来做判断的
              // ISACTIVE: item.ISACTIVE.val, //是否作废
              IS_GROUP: item.IS_GROUP.val, // 是否组合商品
              PRICELIST: item.PRICE_LIST.val, // 零售价
              RATIO: 0, // 占比
              NUM: 1,
            });
          });
          self.tableConfig.data = arr
          self.tableConfig.total = res.data.datas.totalRowCount
          if (res.data.code != 0) {
            this.$Message.warning(res.data.message);
          }
        }
      });
    },
    submit() {
      this.$emit('on-ok', this.tableConfig.selectionData)
    },
    // 回调-用于扩展组件（eg: 零售列表/详情-【添加赠品】弹窗增加“数量”列)
    onBeforeHandle () {
      this.$nextTick(() => {
        if (this.$listeners['on-before-handle']) {
          this.$emit('on-before-handle')
        }
      })
    },
    // 选中某一项时触发
    onSelect(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 取消选中某一项时触发
    onSelectCancel(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击全选时触发
    onSelectAll(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 点击取消全选时触发
    onSelectAllCancel(selection) {
      this.tableConfig.selectionData = selection;
    },
    // 分页change 事件
    pageChange(val) {
      this.tableConfig.current = val;
      this.request();
    },
    // 切换分页条数
    pageSizeChange(val) {
      this.tableConfig.pageSize = val;
      this.request();
    },
  }
};
